/**
 * Created by coolguy on 2017/7/5.
 */
import React from 'react';
import {message,Row} from 'antd';
import Info from '../Detail/Info';
import Add from '../HighListComponent/Add';

const formFrom = [
    {
        "key": "电话预约",
        "name": "电话预约"
    },
    {
        "key": "官网",
        "name": "官网"
    },
    {
        "key": "公众号",
        "name": "公众号"
    },
    {
        "key": "相册预约+订单号",
        "name": "相册预约+订单号"
    },
    {
        "key": "摄影师介绍",
        "name": "摄影师介绍"
    },
    {
        "key": "全新开拓",
        "name": "全新开拓"
    },
    {
        "key": "付费现场转化",
        "name": "付费现场转化"
    },
    {
        "key": "市场活动转化",
        "name": "市场活动转化"
    },
    {
        "key": "老客户介绍",
        "name": "老客户介绍"
    },
    {
        "key": "现场参会者",
        "name": "现场参会者"
    },
    {
        "key": "其他",
        "name": "其他"
    },
    {
        "key": "市场部介绍",
        "name": "市场部介绍"
    }
]
const formType = [
    {
        "key":"直客",
        "name":"直客"
    },
    {
        "key":"高频直客",
        "name":"高频直客"
    },
    {
        "key":"第三方公司",
        "name":"第三方公司"
    },
    {
        "key": "甲方客户",
        "name": "甲方客户"
    },
    {
        "key": "乙方客户",
        "name": "乙方客户"
    },
    {
        "key": "资源置换客户",
        "name": "资源置换客户"
    },
    {
        "key": "行业合作伙伴",
        "name": "行业合作伙伴"
    },
    {
        "key": "摄影师/工作室",
        "name": "摄影师/工作室"
    }
];
class TheAdd extends React.Component{
    componentWillReceiveProps() {
        var temp = window.sessionStorage.getItem('temp');
        window.sessionStorage.setItem('temp', '');
        if(temp) {
            this.props.setKeyValue('name', temp);
        }
    }
    componentWillMount() {
        var temp = window.sessionStorage.getItem('temp');
        window.sessionStorage.setItem('temp', '');
        if(temp) {
            this.props.setKeyValue('name', temp);
        }
    }

    checkInput = (state)=>{
        if(!state.name){
            message.warn("请输入客户公司名");
            return false;
        }
        return true;
    };
    handleData = (data)=>{
        if(!this.checkInput(data)){
            return false;
        }
        let formData = Object.assign({},data);
        !formData.type && (formData.type = formType[0].key);
        !formData.from && (formData.from = formFrom[0].key);
        !formData.shortcut && (formData.shortcut = formData.name);

        delete formData.contacts;
        delete formData.createby;
        return formData;
    };
    render(){
        let {state} = this.props;

        return (
            <div>
                <Row type="flex" align="middle">
                    <Info label="客户公司名" required value={state.name}
                          onChange={(value)=>this.props.setKeyValue("name",value)}/>
                    <Info label="简称" placeholder="默认为客户公司名" value={state.shortcut}
                          onChange={(value)=>this.props.setKeyValue("shortcut",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="客户性质"  type="radio" required value={state.type||formType[0].key}
                          data={formType}
                          onChange={(value)=>this.props.setKeyValue("type",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="来源" required type="radio" value={state.from || formFrom[0].key}
                          data={formFrom}
                          onChange={(value)=>this.props.setKeyValue("from",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="所属行业" value={state.industry}
                          onChange={(value)=>this.props.setKeyValue("industry",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="公司类型" value={state.comptype}
                          onChange={(value)=>this.props.setKeyValue("comptype",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="备注" value={state.remark}
                          onChange={(value)=>this.props.setKeyValue("remark",value)}/>
                </Row>
                <Row type="flex" align="middle">
                    <Info label="绑定人员" value={state.innerid} type="user"
                          onChange={(value)=>this.props.setKeyValue("innerid", value)} />
                </Row>
            </div>
        )
    }
}
export default Add({type:"consumer",name:"客户", rowKey:"id", dispatchName:'showAddConsumer'})(TheAdd);



// WEBPACK FOOTER //
// ./src/components/ConsumerList/AddConsumer.js